export var TriggerAction;
(function (TriggerAction) {
    TriggerAction["Unknown"] = "Unknown";
    TriggerAction["PageOpen"] = "PageOpen";
    TriggerAction["PageLeave"] = "PageLeave";
})(TriggerAction || (TriggerAction = {}));
